/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { metaLocationSearchCities } from '../../axios/metaLocationSearchCities'
import type {
	MetaLocationSearchCitiesError,
	MetaLocationSearchCitiesQueryParams,
	MetaLocationSearchCitiesResponse,
} from '../../types/MetaLocationSearchCities'

export const metaLocationSearchCitiesQueryKey = (params?: MetaLocationSearchCitiesQueryParams) =>
	[{ url: '/meta/cities' }, ...(params ? [params] : [])] as const

export type MetaLocationSearchCitiesQueryKey = ReturnType<typeof metaLocationSearchCitiesQueryKey>

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCities */
export function metaLocationSearchCitiesQueryOptions(
	params?: MetaLocationSearchCitiesQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		MetaLocationSearchCitiesResponse,
		AxiosError<MetaLocationSearchCitiesError>,
		MetaLocationSearchCitiesResponse,
		MetaLocationSearchCitiesQueryKey
	>({
		queryKey: metaLocationSearchCitiesQueryKey(params),
		queryFn: ({ signal }) => metaLocationSearchCities(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCities */
export function useMetaLocationSearchCities<TSelectData = MetaLocationSearchCitiesResponse>(
	params?: MetaLocationSearchCitiesQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MetaLocationSearchCitiesResponse,
					AxiosError<MetaLocationSearchCitiesError>,
					TSelectData,
					MetaLocationSearchCitiesQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MetaLocationSearchCitiesError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...metaLocationSearchCitiesQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCities */
export function useMetaLocationSearchCitiesSuspense<TSelectData = MetaLocationSearchCitiesResponse>(
	params?: MetaLocationSearchCitiesQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MetaLocationSearchCitiesResponse,
					AxiosError<MetaLocationSearchCitiesError>,
					TSelectData,
					MetaLocationSearchCitiesQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MetaLocationSearchCitiesError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...metaLocationSearchCitiesQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
